import { Origin } from "@bitwarden/web-vault/app/models/types/general-types";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { AUSTRALIAN_SUPER_ACCOUNT_MARKER } from "./australian-super-account";
import { AUSTRALIAN_SUPER_PLUGIN_NAME } from "./australian-super.plugin-config";

/**
 * Resolves the data-plugin id that created this account (e.g. "opal-card", "super"), for any
 * `Origin.plugin` account. `basiqAccountId` doubles as the plugin id for generic plugins;
 * Australian Super keeps its legacy marker string (accounts synced before per-plugin tagging
 * existed) and is mapped back to its plugin id here.
 */
export function getPluginIdForAccount(
  account: Pick<AccountView, "origin" | "basiqAccountId"> | undefined,
): string | undefined {
  if (!account || account.origin !== Origin.plugin || !account.basiqAccountId) {
    return undefined;
  }
  if (account.basiqAccountId === AUSTRALIAN_SUPER_ACCOUNT_MARKER) {
    return AUSTRALIAN_SUPER_PLUGIN_NAME;
  }
  return account.basiqAccountId;
}
